import { getNormalizedBranch } from '../utils';

import * as ActionTypes from './constants';

export const defaultState = () => {
  return {
    branches: [],
    pending: false,
    error: null,
  };
};

export function branches(state = defaultState(), action) {
  const { type, payload, error } = action;

  if (type === ActionTypes.GET_BRANCHES_REQUEST) {
    return {
      ...state,
      error: null,
      pending: true,
    };
  }

  if (type === ActionTypes.GET_BRANCHES_SUCCESS) {
    return {
      ...state,
      branches: payload.map(getNormalizedBranch),
      error: null,
      pending: false,
    };
  }

  if (type === ActionTypes.GET_BRANCHES_FAILURE) {
    return {
      ...state,
      error,
      branches: [],
      pending: false,
    };
  }

  if (type === ActionTypes.RESET_BRANCHES) {
    return defaultState();
  }

  return state;
}
